/**
 * A enum representing the surface of an SD UI view
 */
export var DisplayPageType;
(function (DisplayPageType) {
    DisplayPageType["DISPLAY_PAGE_TYPE_UNKNOWN"] = "DISPLAY_PAGE_TYPE_UNKNOWN";
    DisplayPageType["HOMEPAGE"] = "HOMEPAGE";
    DisplayPageType["CATEGORY_PAGE"] = "CATEGORY_PAGE";
    DisplayPageType["PRODUCT_PAGE"] = "PRODUCT_PAGE";
    DisplayPageType["CART_PAGE"] = "CART_PAGE";
    DisplayPageType["SIMILAR_PRODUCTS_PAGE"] = "SIMILAR_PRODUCTS_PAGE";
    DisplayPageType["SEARCH_PAGE"] = "SEARCH_PAGE";
    DisplayPageType["DIGEST_PAGE"] = "DIGEST_PAGE";
    DisplayPageType["BRAND_DETAILS_PAGE"] = "BRAND_DETAILS_PAGE";
})(DisplayPageType || (DisplayPageType = {}));
